import { render } from "./AccountMall.vue?vue&type=template&id=4f5f8ace&scoped=true"
import script from "./AccountMall.vue?vue&type=script&lang=js"
export * from "./AccountMall.vue?vue&type=script&lang=js"

import "./AccountMall.vue?vue&type=style&index=0&id=4f5f8ace&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5f8ace"]])

export default __exports__